<template>
  <FullPageLayout v-if="IS_ONEDIO">
    <PreviousGamesPage />
  </FullPageLayout>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import PreviousGamesPage from '~/modules/oyun/components/previousGames/PreviousGamesPage.vue';
import { IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  components: {
    FullPageLayout,
    PreviousGamesPage,
  },
  setup() {
    return { IS_ONEDIO };
  },
});
</script>
